__turbopack_context__.v({
  "dealName": "correctionModal-module-scss-module__Oj763q__dealName",
  "headerText": "correctionModal-module-scss-module__Oj763q__headerText",
  "hidden": "correctionModal-module-scss-module__Oj763q__hidden",
  "inputContainer": "correctionModal-module-scss-module__Oj763q__inputContainer",
  "modalDescription": "correctionModal-module-scss-module__Oj763q__modalDescription",
  "textarea": "correctionModal-module-scss-module__Oj763q__textarea",
});
